module.exports = __webpack_public_path__ + "img/logo-olvid.18a2d619.png";